import React from 'react';
import Button from './Button';
import heroImage from "../assets/images/hero_img_2.avif";
import logoLeft from "../assets/images/logo_left.png";
import logoRight from "../assets/images/logo_right.png";
import logoCenter from "../assets/images/iasg_mid_logo.png";
// const HERO_PLACEHOLDER = 'https://placehold.co/1920x900/001a40/ffffff?text=IASG+Mid-Term+Conference+2026';

function HeroSection() {
  return (
    <section id="overview" className="hero section">
      <div className="hero-bg">
        <img src={heroImage} alt="" className="hero-bg-image" />
      </div>
      <div className="container hero-inner">
        <div className="hero_logo_section_wrapper">
          <img src={logoLeft} alt="IASG Mid-Term Conference 2026" className="hero-logo-left" />
          <hr className="hero-logo-divider" />
          <img src={logoCenter} alt="IASG Mid-Term Conference 2026" className="hero-logo-center" />
          <hr className="hero-logo-divider" />
          <img src={logoRight} alt="IASG Mid-Term Conference 2026" className="hero-logo-right" />
        </div>
        <h1 className="hero-title">
          <span className="hero-title-line hero-title-accent">MID-TERM CONFERENCE 2026</span>
        </h1>
        <h2 className="hero-title-line-2">Indian Association of Surgical Gastroenterology</h2>
        <p className="hero-subtitle">
          G.I Oncology: From Basics to Clinical Practice. Join us at Patna for two days of orations, keynotes, skill labs, and expert discussions.
        </p>
        <div className="hero-meta">
          <span className="hero-pill">
            <i className="ri-calendar-line" aria-hidden="true" />
            28 & 29 March 2026
          </span>
          <span className="hero-pill">
            <i className="ri-map-pin-line" aria-hidden="true" />
            Hotel Chanakya, Patna, Bihar (India)
          </span>
        </div>
        <div className="hero-ctas">
          <Button variant="primary" href="#registration" iconRight="ri-arrow-right-line" className="hero-cta" onClick={() => {
            window.open("https://iasg.register.enhance.events/midtermconference2026", "_blank");
          }}>
            Register Now
          </Button>
          <Button variant="secondary" href="#program" iconRight="ri-arrow-right-line" className="hero-cta">
            View Program
          </Button>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
